"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CallEnd_1 = __importDefault(require("@material-ui/icons/CallEnd"));
const IconButton_1 = __importDefault(require("../IconButton"));
const styles_1 = __importDefault(require("./styles"));
const EndCallButton = ({ id = 'end-call', label, loading = false, onClick = () => { }, }) => {
    const classes = styles_1.default();
    return (react_1.default.createElement(IconButton_1.default, { id: id, label: label, loading: loading, onClick: onClick, ariaLabel: id },
        react_1.default.createElement(CallEnd_1.default, { className: classes.icon })));
};
exports.default = EndCallButton;
